import './styles/globals.css'
import { Box, Grid, Link } from '@mui/material'
import styles from './styles/Home.module.css'
import karmaStyles from './styles/KarmaPool.module.css'
import './App.css';
import AccountMenu from './account-menu'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomepageRoot from './components/homepage/HomepageRoot';
import HomepageLogin from './components/homepage/HomepageLogin';
import HomepageRegister from './components/homepage/HomepageRegister';
import DashboardRoot from './components/dashboard/DashboardRoot';
import DashboardCausesNew from './components/dashboard/DashboardCausesNew';
import DashboardPool from './components/dashboard/DashboardPool';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { KarmaPoolProvider } from './state/KarmaPoolContext';
import AdminDashboardRoot from './components/dashboard/admin/AdminDashboardRoot';
import AdminDashboardPool from './components/dashboard/admin/AdminDashboardPool';
import AdminDashboardCycles from './components/dashboard/admin/AdminDashboardCycles';
import AdminDashboardUsers from './components/dashboard/admin/AdminDashboardUsers';
import AdminDashboardCauses from './components/dashboard/admin/AdminDashboardCauses';
import DashboardDonations from './components/dashboard/DashboardDonations';

import smallLogo from './images/small_logo.png';
import Newsletter from './components/dashboard/newsletter/Newsletter';
import AdminDashboardRegistrationCodes from './components/dashboard/admin/AdminDashboardRegistrationCodes';
import DashboardSocial from './components/dashboard/DashboardSocial';
import DashboardProfile from './components/dashboard/DashboardProfile';
import DashboardMembership from './components/dashboard/DashboardMembership';
import { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import DashboardMembershipSuccess from './components/dashboard/DashboardMembershipSuccess';
import DashboardFAQ from './components/dashboard/DashboardFAQ';
import AdminDashboardNewsletter from './components/dashboard/admin/AdminDashboardNewsletter';
import DashboardCycle from './components/dashboard/DashboardCycle';
import HomepageDonations from './components/homepage/HomepageDonations';
import InvitePage from './components/invite/InvitePage';
import DashboardRegistrationWelcome from './components/dashboard/welcome/DashboardRegistrationWelcome';
import HomepageAbout from './components/homepage/HomepageAbout';
import HomepageAbout2 from './components/homepage/HomepageAbout2';

const theme = createTheme({
  palette: {
    MuiLink: {
      defaultProps: {
        color: 'secondary',
      },
    },
    primary: {
      light: "#222",
      main: '#fff',
      secondary: '#81d9fb',
      contrastText: '#fff',
    },
    secondary: {
      main: "#81d9fb",
      light: "#f0f",
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 750,
      lg: 1200,
      xl: 1536,
    },
  },
});

function App() {

  return (
    <ThemeProvider theme={theme}>
      <KarmaPoolProvider>
        <div className={styles.container}>
          <div>
            <title>Karma Pool</title>
            <meta name="description" content="The collective giving app." />
            <link rel="icon" href="https://karmatic.com/favicon.ico" />
          </div>

          <main className={styles.main}>
            <Grid container spacing={0}>
              <Grid className={styles.header} item xs={10}>
                {/* add in small_logo.png image at full size */}
                <a href="/" rel="noreferrer">
                  <img src={smallLogo}
                    width="206px"
                    height="76px"
                    alt="Karmatic" />
                </a>
              </Grid>
              <Grid className={styles.headerMenu} item xs={2}>
              </Grid>
              <Grid className={styles.kapp} item xs={12}>
                <Router>
                  <Routes>
                    <Route path="/karma" element={<HomepageRoot />} />
                    <Route path="/karma/about" element={<HomepageAbout />} />
                    <Route path="/karma/about2" element={<HomepageAbout2 />} />
                    <Route path="/karma/EXP" element={<InvitePage inviteCode={"EXP-INV"} inviteCodeDisplay={"EXP"}  />} />
                    <Route path="/karma/friends" element={<InvitePage inviteCode={"FRI-END"} inviteCodeDisplay={"FRIENDS"} />} />
                    <Route path="/karma/login" element={<HomepageLogin />} />
                    <Route path="/karma/register" element={<HomepageRegister />} />
                    <Route path="/karma/donations" element={<HomepageDonations />} />
                    <Route path="/karma/dashboard" element={<DashboardRoot />} />
                    <Route path="/karma/dashboard/welcome" element={<DashboardRegistrationWelcome />} />
                    <Route path="/karma/dashboard/donations" element={<DashboardDonations />} />
                    <Route path="/karma/dashboard/social" element={<DashboardSocial />} />
                    <Route path="/karma/dashboard/faq" element={<DashboardFAQ />} />
                    <Route path="/karma/dashboard/membership" element={<DashboardMembership />} />
                    <Route path="/karma/dashboard/membership/success" element={<DashboardMembershipSuccess />} />
                    <Route path="/karma/dashboard/profile" element={<DashboardProfile />} />
                    <Route path="/karma/dashboard/causes" element={<DashboardCausesNew />} />
                    <Route path="/karma/dashboard/cycle" element={<DashboardCycle />} />
                    <Route path="/karma/dashboard/pool" element={<DashboardPool />} />
                    <Route path="karma/dashboard/newsletter" element={<Newsletter />} />
                    <Route path="/karma/dashboard/admin" element={<AdminDashboardRoot />} />
                    <Route path="/karma/dashboard/admin/pool" element={<AdminDashboardPool />} />
                    <Route path="/karma/dashboard/admin/cycles" element={<AdminDashboardCycles />} />
                    <Route path="/karma/dashboard/admin/users" element={<AdminDashboardUsers />} />
                    <Route path="/karma/dashboard/admin/causes" element={<AdminDashboardCauses />} />
                    <Route path="/karma/dashboard/admin/registration" element={<AdminDashboardRegistrationCodes />} />
                    <Route path="/karma/dashboard/admin/newsletter" element={<AdminDashboardNewsletter />} />
                  </Routes>
                </Router>
              </Grid>
            </Grid>
          </main>
          <footer className={styles.footer}>
          </footer>
        </div >
      </KarmaPoolProvider>
    </ThemeProvider>
  );
}

export default App;
